import React from 'react'
import { useGuestNameQuery } from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'

type GuestNameLabelProps = {
  guestId: string
  renderLoading?: React.ReactNode
}

const GuestNameLabel = (props: GuestNameLabelProps) => {
  const { id: tenantId } = useTenant()

  const { data, loading } = useGuestNameQuery({ variables: { tenantId, guestId: props.guestId } })

  if (loading) {
    return <div>{props.renderLoading}</div>
  }

  if (!data?.customers) {
    console.log(`Unable to find customer name with id ${props.guestId}`)
    return <></>
  }

  return <div>{data.customers[0].name}</div>
}

export default GuestNameLabel
